import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';

import useQuestion from '../useQuestion';
import useStyles from './styles';
import RenderIf from '../../../../renderIf';
import { ShipyardContext } from '../../../../Context';
import InvalidReason from '../invalidReason';

const DropdownMultiple = (props) => {
    const { question, appInstanceId, shouldShowErrors, disabled, answerUpdated } = props;

    //#TODO TechDebt - This is only necessary because the Parent Application view was designed to manipulate these questions directly rather than properly calling setters. This needs to be refactored.
    const handleQuestion = (newQuestion) => {
        question.chosenOptions = newQuestion.chosenOptions;
        question.isValid = newQuestion.isValid;
        question.invalidReason = newQuestion.invalidReason;
        answerUpdated();
    };

    const { userSettings } = React.useContext(ShipyardContext);

    const { id, chosenOptions, text, isSaving, isValid, showErrors, minResponseRequired, invalidReason, options, update, save } =
        useQuestion(question, appInstanceId, shouldShowErrors, handleQuestion);

    const classes = useStyles();

    return (
        <div
            style={{
                marginBottom: '1rem',
            }}
        >
            <label
                className={classNames({
                    [classes.label]: true,
                    [classes.required]: minResponseRequired > 0,
                })}
                data-error={showErrors && !isValid}
                htmlFor={'quest-' + id}
            >
                <ReactMarkdown
                    children={text['en-US']}
                    linkTarget="_blank"
                />

                <RenderIf isTrue={isSaving}>
                    <FontAwesomeIcon
                        className={classes.spinner}
                        icon={faSpinner}
                    />
                </RenderIf>
            </label>

            <div
                style={{
                    maxWidth: 400,
                }}
            >
                <Select
                    id={'quest-' + id}
                    aria-describedby={'quest-err-' + id}
                    className={classes.select}
                    size="small"
                    multiple
                    error={showErrors && !isValid}
                    value={chosenOptions}
                    IconComponent={(props) => (
                        <FontAwesomeIcon
                            {...props}
                            icon={faAngleDown}
                        />
                    )}
                    onChange={(event) => update(event.target.value)}
                    onClose={() => save()}
                    disabled={disabled || isSaving}
                >
                    {options.map((option) => {
                        return (
                            <MenuItem
                                key={`quest-${id}-opt-${option.id}`}
                                value={option.id}
                                className={classes.option}
                                disabled={option?.isDisplayOnly === 1}
                            >
                                {option.text[userSettings.LanguagePreference]}
                            </MenuItem>
                        );
                    })}
                </Select>

                <RenderIf isTrue={showErrors && !isValid}>
                    <InvalidReason
                        className={classes.invalidReason}
                        text={invalidReason}
                        lang={userSettings.LanguagePreference}
                    />
                </RenderIf>
            </div>
        </div>
    );
};

export default DropdownMultiple;
